import { UUID } from '@myme/utils';
import { mymeDetailsPageRoute } from 'src/routes/route-list';
import { toast, ToastType } from 'src/utils';
import { useTranslation } from './useTranslation';

export const useShareMyme = () => {
  const { t } = useTranslation();

  const handleCopyToClipboard = async (id: UUID) => {
    await navigator.clipboard.writeText(`${window.location.origin}${mymeDetailsPageRoute(id)}`);
    toast(ToastType.SUCCESS, t('defaults.clipboard_copy'));
  };

  return handleCopyToClipboard;
};
